export default "__VITE_ASSET__N9wuaRXo__"